import { useState } from 'react';

/**
 * The value from the render where `key` last changed: a list rebuilt on every
 * render keeps its identity while its CONTENT (summarized by the key) holds, so an
 * effect can depend on it directly without waking up on every render. The swap
 * happens during render (React's "storing information from previous renders"),
 * not through a ref written during render.
 */
export function useKeyedValue<T>(value: T, key: string = JSON.stringify(value)): T {
  const [held, setHeld] = useState({ key, value });
  if (held.key === key) return held.value;
  setHeld({ key, value });
  return value;
}
